// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { MedicalBiResultSearchBase } from './medicalBiResultSearchBase.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalBiResultSearchResponse {
    'results': Array<MedicalBiResultSearchBase>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalBiResultSearchResponse>> = [
        {
            "name":     "results",
            "baseName": "results",
            "type":     "Array<MedicalBiResultSearchBase>"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalBiResultSearchResponse.attributeTypeMap;
    }
}
